import type { GridMetadata } from '../../menu/types';
import { resolveGridReactCommand } from './registry';
import type { ActiveGridReactCommand, GridReactCommandRegistry } from './types';

type GridReactCommandHostProps = {
  activeCommand: ActiveGridReactCommand | null;
  metadata: GridMetadata;
  onClose: () => void;
  registry?: GridReactCommandRegistry;
};

export const GridReactCommandHost = ({
  activeCommand,
  metadata,
  onClose,
  registry,
}: GridReactCommandHostProps) => {
  if (!activeCommand) return null;

  const render = resolveGridReactCommand(activeCommand.command.renderingClass, registry);
  if (!render) return null;

  return render({
    row: activeCommand.row,
    command: activeCommand.command,
    metadata,
    onClose,
  });
};
